import { Component, OnInit, AfterViewChecked, AfterViewInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'gn-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnInit, AfterViewInit, AfterViewChecked {
  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    $('.toggle-nav, #site-overlay').on('click', () => {
      $('html, .nav-mobile, #site-overlay').toggleClass('nav-mobile-opened');
      if ($('.nav-mobile').hasClass('nav-mobile-opened')) {
        $('.nav-mobile').show();
        $('body').css('overflow', 'hidden');
        $('.nav-mobile a').attr('tabindex', '0');
        $('.close.toggle-nav').focus();
        $('#menu-bars-bars').attr('aria-expanded', 'true');
      } else {
        $('body').css('overflow', '');
        $('#menu-bars-bars').focus();
        $('#menu-bars-bars').attr('aria-expanded', 'false');
        $('.nav-mobile,.nav-mobile a').attr('tabindex', '-1');
        $('.nav-mobile').hide();
      }
    });
    /**
     * For Close Button (Handles for both collapsed and expanded)
     */
    $('.controls .toggle-nav').keydown(e => {
      const keyvalue = e.which;
      const shifted = e.shiftKey;
      if (keyvalue === 9 && shifted) {
        e.preventDefault();
        if ($('#mobile-global-links a').length > 0) {
          $('.nav-mobile a:eq(-1)').focus();
        } else {
          if ($('ul#nav-mobile-collapse > li:last').hasClass('active') && $('.nav-mobile li.active a:eq(0)').hasClass('collapsed')) {
            $('.nav-mobile li.active a:eq(0)').focus();
          } else {
            $('.nav-mobile a:eq(-1)').focus();
          }
        }
      }
    });

    $('#menu-bars-bars').keydown(e => {
      if (e.which === 9 && e.shiftKey && $('#global-links-bar').is(":hidden")) {
          e.preventDefault();
          $('#skip').focus();
      }
    });
    $('#skip').keydown(e => {
      if (e.which === 9 && !(e.shiftKey) && $('#global-links-bar').is(":hidden")) {
          e.preventDefault();
          $('#menu-bars-bars').focus();
      }
    });

    /**
     * For Last list item (Handles for both collapsed and expanded)
     */
    $(document).on('keydown', 'ul#nav-mobile-collapse > li:last', e => {
      const keyvalue = e.which;
      const shifted = e.shiftKey;
      if (keyvalue === 9 && !shifted) {
        if ($('#mobile-global-links a').length == 0) {
          e.preventDefault();
          $('.controls .toggle-nav').focus();
        }
      }
    });

    $(document).on('keydown', 'ul#mobile-global-links > li:last', e => {
      if (e.which === 9 && !(e.shiftKey)) {
        e.preventDefault();
        $('.controls .toggle-nav').focus();
      }
    });

  }

  ngAfterViewChecked(): void {
    if ($('.nav-mobile').hasClass('nav-mobile-opened')) {
      $('body').css('overflow', 'hidden');
      $('.nav-mobile a').attr('tabindex', '0');
    } else {
      $('body').css('overflow', '');
      $('.nav-mobile,.nav-mobile a').attr('tabindex', '-1');
    }

    if ($('#global-links-bar').is(":visible")) {
      $('#global-links-bar a').attr('tabindex', '0');
    } else {
      $('#global-links-bar a').attr('tabindex', '-1');
    }

    $('.nav-mobile a:not(.accordion-icon-control)').on('click', () => {
      if ($('html, .nav-mobile, #site-overlay').hasClass('nav-mobile-opened')) {
        $('html, .nav-mobile, #site-overlay').removeClass('nav-mobile-opened');
        $('body').css('overflow', '');
      }
    });
  }
}
